<fieldset>
 <legend>
  Attribution
 </legend>
 <fieldset>
 <legend>
  resultat
 </legend>
 <app-type-resultat-attribution  [uid]="getUid()" [parentForm]="parentForm" [resultat]="attribution.resultat"></app-type-resultat-attribution>
</fieldset>

<!---->

<button class="btn btn-outline-primary" (click)="addlotMarche()">Ajouter un lotMarche</button>
<div *ngFor="let obj of attribution.lotMarche; let i = index">
  <fieldset>
    <legend>
      lotMarche {{ i + 1}}
    </legend>
    <button class="btn btn-outline-primary" (click)="removelotMarche(i)">Supprimer un lotMarche</button>
    <app-lot-marche [uid]="getUid()+'_index_'+(i+1)" [parentForm]="parentForm" [lotMarche]="obj"></app-lot-marche>
  </fieldset>
</div>

</fieldset>
